import React, { useEffect, useState } from "react";
import QuantityModal from "./QuantityModal";
import { ModalModel } from "../../models/CommonModel";
import { getProduct } from "./CartCRUD";
import { SessionCartModel } from "../../models/SessionCartModel";
import _ from "lodash";
import { IOrderProduct } from "../../models/OrderModel";
import { Toast } from "../../modules/common/helper";
import { IProductOrderResource } from "../../modules/auth/models/ProductsModel";
import { useHistory } from "react-router-dom";

type Props = {
    id?: string | number
    qrType?: string
    isBarCode?: number
}

type QrType = 'order' | 'receipt' | 'checksheet';

const AddToCart: React.FC<Props> = ({id, qrType, isBarCode}) => {
    const qrTypeConfig = {
        order: {
            storage_name: 'cart',
            redirect_url: '/orders/detail?createFromCart=1',
            cancel_url: '/orders'
        },
        receipt: {
            storage_name: 'receipt_cart',
            redirect_url: '/warehouse/receipt/detail?createFromCart=1',
            cancel_url: '/warehouse/receipt/list'
        },
        checksheet: {
            storage_name: 'checksheet_cart',
            redirect_url: '/warehouse/inventory-check-sheet/detail?createFromCart=1',
            cancel_url: '/warehouse/inventory-check-sheet'
        }
    }
    const [quantityModal, setQuantityModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const history = useHistory();
    const config = qrTypeConfig[(qrType as QrType) || 'order'] || qrTypeConfig['order'];
    const cartStorage = config.storage_name;
    const redirectUrl = config.redirect_url;

    useEffect(() => {
        if (id) {
            initAddToCartProcess();
        }
    }, [])

    const initAddToCartProcess = async () => {
        try {
            const { data }: { data: IProductOrderResource } = await getProduct(id, isBarCode, true);
            let cartData = JSON.parse(localStorage.getItem(cartStorage) || '[]');
        
            let pdIndex = _.findIndex(cartData, function (item: SessionCartModel)  {
                return item.id == data.data.id;
            })
            let initQty = 1;
            if (pdIndex >= 0) {
                initQty = cartData[pdIndex].qty
            }
            setQuantityModal({...quantityModal, data: {...data.data, qty: initQty}, show: true});
        } catch (error: any) {
            if (error?.response?.status === 404) {
                Toast.fire({
                    title: 'Không tìm thấy sản phẩm. Vui lòng tạo mới!',
                    icon: 'error'
                })
            }
            if (isBarCode && error?.response?.status === 404) {
                history.push('/products/detail?barCode=' + id);
                return;
            }
            return;
        }
    }

    const handleAddTocart = async (data: IOrderProduct, qty: number) => {
        let cartData = JSON.parse(localStorage.getItem(cartStorage) || '[]');
        
        let pdIndex = _.findIndex(cartData, function (item: SessionCartModel)  {
            return item.id == data.id;
        })

        if (pdIndex >= 0) {
            cartData[pdIndex] = {...cartData[pdIndex], qty: qty, inventory_of_sento: data}
        } else {
            cartData.push({id: data.id, qty: qty, inventory_of_sento: data, product_name: data.name});
        }
        localStorage.setItem(cartStorage, JSON.stringify(cartData));
        setQuantityModal({...quantityModal, show: false})
        Toast.fire({
            icon: 'success',
            title: 'Đã thêm vào giỏ hàng'
        })
        history.push(redirectUrl);
    } 

    const handleCancel = () => {
        setQuantityModal({ ...quantityModal, show: false });
        history.push(config.cancel_url);
    }
    return (
    
        <QuantityModal 
            {...quantityModal}
            handleAddTocart={handleAddTocart}
            qrType={qrType}
            onClose={handleCancel}
        />
    )
}
export default AddToCart;